import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import ProgressBar from '../../../../components/progress-bar';
// Import Actions
import { loadBenchmark, updateBenchmark } from '../../SetupActions';
import SearchForm from '../../../../components/search-form';
import DateRangeField from '../../../../components/search-form/date-range-field';
import { getSearchQuery, cleanSubmitCriteria } from '../../../../components/search-form/search-form-reducer';
import ModifiedLog from '../DiscoveryBotPage/ModifiedLog';

class BenchmarkDetailPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
      benchmark: null,
      formReady: false,
      currentSelectedRange: null,
      currentDateControlType: DateRangeField.MODE_CUSTOM_RANGES,
    };

    this.handleDateRangeUpdate = this.handleDateRangeUpdate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentDidMount() {
    this.loadBenchmark();
  }

  handleDateRangeUpdate(path, d) {
    this.setState({ 
      currentSelectedRange: d.values,
      currentDateControlType: d.control_type
    }, () => {
      this.props.change('date_ranges', d.values);
    });
  }


  handleLoad(benchmark) {
    benchmark.query = benchmark.query || {};
    let currentSelectedRange = null;
    let currentDateControlType = null;
    const detectedControl = DateRangeField.detectControlType(benchmark.date_ranges);
    if (detectedControl) {
      currentSelectedRange = detectedControl.value;
      currentDateControlType = detectedControl.mode;
    } else {
      currentSelectedRange = [];
      currentDateControlType = DateRangeField.MODE_CUSTOM_RANGES;
    }

    this.setState({ loading: false, loaded: true, benchmark, currentSelectedRange, currentDateControlType }, () => {
      this.props.initialize({
        date_ranges: currentSelectedRange,
        query: benchmark.query,
      });
    });
  }

  handleSubmit() {
    const { type } = this.props;
    const params = {
      ...(type === 'outcomes' ? { date_ranges: this.state.currentSelectedRange } : {}),
    };
    if (this.state.formReady) {
      const searchQuery = cleanSubmitCriteria(this.props.searchQuery);
      params.query = searchQuery;
    }
    const p = this.props.dispatch(updateBenchmark(this.props.type, this.props.subType, params));
    return p.then(
      ({ benchmark }) => {
        this.handleLoad(benchmark);
      },
      (errors) => {
        const e = errors.data || errors;
        throw new SubmissionError(e);
      },
    );
  }

  loadBenchmark() {
    this.setState({ loading: true, loaded: false, benchmarks: [] }, () => {
      this.props.dispatch(loadBenchmark(this.props.type, this.props.subType))
        .then(
          ({ benchmark }) => {
            this.handleLoad(benchmark);
          },
          () => {

          },
        );
    });
  }

  renderField({
    meta: { touched, error }, searchType,
  }) {
    const { submitting } = this.props;
    const { currentDateControlType, currentSelectedRange } = this.state;
    // const validationState = touched && error ? 'error' : null;
    return (
      <DateRangeField
        path={[]}
        level={1}
        showDelete={false}
        showInclude={false}
        disabled={submitting}
        renderDescription
        searchCriteria={{
          _id: 'main-close-date',
          type: 'include',
          filter: {
            _id: 'main-close-date',
            label: 'Close Date',
            // description: '',
          },
          values: currentSelectedRange,
          control_type: currentDateControlType,
        }}
        onUpdate={this.handleDateRangeUpdate}
        searchType={searchType}
      >
        {touched && error && <div className="text-danger">{error}</div>}
      </DateRangeField>
    );
  }

  renderResults() {
    const { benchmark } = this.state;
    const { submitting, handleSubmit, valid, type } = this.props;
    
    const searchType = `benchmarks/${this.props.type}/${this.props.subType}`;

    const innerFields = type === 'outcomes' ? (
      <Field
        name="date_ranges"
        component={this.renderField}
        searchType={searchType}
      />
    ) : null;

    return (
      <div>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <SearchForm
            key={`form-${benchmark._id}`}
            dropup
            onSearchChange={() => {
              this.setState({ formReady: true });
            }}
            disabled={submitting}
            standalone
            showRootLogicalORWarning
            defaultCriteria={benchmark.query}
            type={searchType}
          >
            {innerFields}
          </SearchForm>
          <hr />
          <div className="clearfix">
            <div className="pull-left">
              <ModifiedLog value={benchmark} />
            </div>
            <Button className="pull-right" bsStyle="primary" disabled={!valid || submitting} type="submit">
              {!submitting && <span>Save</span>}
              {submitting && <span><Fa name="spinner" spin /> Saving</span>}
            </Button>
          </div>
        </form>
      </div>
    );
  }

  render() {
    const { loading, loaded } = this.state;
    return (
      <div>
        <div>
          {loading && <ProgressBar />}
          {!loading && loaded && this.renderResults()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const searchType = `benchmarks/${ownProps.type}/${ownProps.subType}`;
  return {
    searchQuery: getSearchQuery(searchType, state),
  };
}

BenchmarkDetailPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  subType: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  searchQuery: PropTypes.shape({}),
};

BenchmarkDetailPage.defaultProps = {
  searchQuery: {},
};

BenchmarkDetailPage.contextTypes = {
};

const BenchmarkForm = reduxForm({
  form: 'benchmarksSettings',
}, { touchOnChange: true })(BenchmarkDetailPage);


export default withRouter(connect(mapStateToProps)(BenchmarkForm));
